// import { INAV_VARIANTS } from '../../utils/constants';

// if peristOnSnr is true please pass experimentVariants as array from your holocron while saving.
// const getExperimentDetails = ({
//   experimentName,
//   dimensionName,
//   defaultVariant = INAV_VARIANTS.CONTROL,
//   peristOnSnr,
//   variants = [INAV_VARIANTS.CONTROL, INAV_VARIANTS.INAV_VAR_A],
// }) => ({
//   experimentName,
//   dimensionName,
//   defaultVariant,
//   variants,
//   peristOnSnr,
// });

// CA Market Config
// control - axp-global-header, variantA - Simplified header
// showExitModal in props is to show the exit modal. This exit modal content is cusomtized
// modal content can be passed from journey to root module using handleExitModal call back.
// Refer CA Market.
// Below code will be added For the next release after MX
// const caInavConfig = {
//   props: {
//     showExitModal: true,
//   },
//   inavLiteJourney: [],
//   ignoreInavLiteModules: ['axp-retrieve-application'],
//   experimentDetails: getExperimentDetails({
//     experimentName: 'eApply-CA-Inav',
//     dimensionName: 'inav_lite',
//     peristOnSnr: true,
//   }),
// };

/**
 * If any market needs to have simple inav please add a config to your market.
 * `inavLiteJourney` is to determine, to which journey we need to show the inavLite.
 *     Add the journey="personal" or "sbs" as prop to your route in childRoutes.jsx
 * `ignoreInavLiteModules` -
 *    is to prevent loading inavLite to the whole module irrespective of any journey.
 * `props` -
 *    to control the additional feature for the inav, Ex:  browser close tab is part of this inav.
 * `experimentDetails` is to have different variants of inav running in experiments
 * If no config is given it will have control by default for all the route (axp-global-header)
 */
export const inavMarketsDetails = {
  'es-mx': {
    inavLiteJourney: {
      personal: {},
      sbs: {},
    },
    ignoreInavLiteModules: ['axp-retrieve-application'],
    props: {
      showExitModal: true,
      showExitButtonInHeader: true,
    },
  },
  'ja-jp': {
    inavLiteJourney: {
      personal: {},
      sbs: {},
    },
    ignoreInavLiteModules: ['axp-retrieve-application'],
    props: {
      showExitModal: true,
      showExitButtonInHeader: false,
      showExitButtonStyle: true,
    },
  },
  'en-gb': {
    inavLiteJourney: {
      personal: {},
    },
    ignoreInavLiteModules: ['axp-retrieve-application'],
    props: {
      showExitModal: true,
      showExitButtonInHeader: true,
      showExitButtonStyle: true,
      showUnderLineText: true,
    },
  },
};
